function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from "react";
import moment from "moment-timezone";
import { FilterContext } from "../index";
import Loader from "./../Loader/Loader";
import { useTable, useSortBy } from "react-table";
import Select from "react-select";
import DatePicker from "react-datepicker";
import Button from "react-bootstrap/Button";
import "./DailyAttendance.css";
import { HiDownload, HiOutlineSelector, HiChevronDown, HiChevronUp } from "react-icons/hi";
import { GET_DAILY_WORKED_QUERY, GET_DAILY_ABSENT_QUERY, GET_DAILY_LATE_QUERY, USER_WORKED_LISTING_QUERY, USER_ABSENT_LISTING_QUERY, USER_LATE_LISTING_QUERY, GET_DAILY_WORKED_QUERY_EXPORT, GET_DAILY_ABSENT_QUERY_EXPORT, GET_DAILY_LATE_QUERY_EXPORT, GET_UNINFORMED_LEAVE_DETAILS_QUERY, USER_UNINFORMED_LEAVE_QUERY, GET_UNINFORMED_LEAVE_DETAILS_EXPORT_QUERY } from "./query";
import { useQuery, useLazyQuery } from "@apollo/client";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { subDays } from "date-fns";
import Excel from "exceljs/dist/es5/exceljs.browser";
import { saveAs } from "file-saver";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { arrayToStringOutput, startOfDayCheck, endOfDayCheck } from "./../SideMenu/Header";
var LIMIT = 10;
var offsets = 0;
var ABSENT_LIMIT = 10;
var offsetsAbsent = 0;
var LATE_LIMIT = 10;
var offsetsLate = 0;
var UNINFORMED_LIMIT = 10;
var offsetsUninformed = 0;
function checkExpectedClockInReached(organisationSettings) {
  var todayDate = moment().tz(organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone).format("DD-MM-YYYY");
  var expectedTime = moment(organisationSettings.expectedClockInTime).format("HH:mm A");
  var expectedClockInTimeFormate = moment(todayDate + " " + expectedTime, "DD/MM/YYYY HH:mm A").valueOf();
  if (expectedClockInTimeFormate < moment().tz(organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone).valueOf()) {
    return true;
  }
  return false;
}
var DailyAttendance = function DailyAttendance(props) {
  var _props$match$params, _absentDataUser$getDa, _absentDataUser$getDa2;
  var Link = props.linkComponent,
    linkProps = props.linkProps;
  var _React$useContext = React.useContext(FilterContext),
    teamId = _React$useContext.teamId,
    organisationId = _React$useContext.organisationId,
    organisationSettings = _React$useContext.organisationSettings,
    role = _React$useContext.role,
    organisationBilling = _React$useContext.organisationBilling,
    from = _React$useContext.from,
    sD = _React$useContext.startDate,
    eD = _React$useContext.endDate,
    organisationStatus = _React$useContext.organisationStatus;

  //  WORKFOLIO MAINTENANCE REDIRECTION
  // React.useEffect(() => {
  //   props?.history.push("/workfolio-maintenance");
  // }, []);

  var currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  var _React$useState = React.useState(startOfDayCheck(currentTimezone, organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone) ? moment().tz(currentTimezone).clone().startOf("day").toDate() : endOfDayCheck(currentTimezone, organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone) ? moment().tz(currentTimezone).clone().endOf("days").toDate() : moment().tz(currentTimezone).clone().toDate()),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    startDate = _React$useState2[0],
    setStartDate = _React$useState2[1];
  var pageType = props === null || props === void 0 ? void 0 : (_props$match$params = props.match.params) === null || _props$match$params === void 0 ? void 0 : _props$match$params.pageType;

  //loadmore
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isAllLoaded = _React$useState4[0],
    setIsAllLoaded = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isLoadingMore = _React$useState6[0],
    setIsLoadingMore = _React$useState6[1];
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isLoadMoreButton = _React$useState8[0],
    setIsLoadMoreButton = _React$useState8[1];
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    isAbsentAllLoaded = _React$useState10[0],
    setIsAbsentAllLoaded = _React$useState10[1];
  var _React$useState11 = React.useState(false),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    isAbsentLoadingMore = _React$useState12[0],
    setIsAbsentLoadingMore = _React$useState12[1];
  var _React$useState13 = React.useState(false),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    isAbsentLoadMoreButton = _React$useState14[0],
    setIsAbsentLoadMoreButton = _React$useState14[1];
  var _React$useState15 = React.useState(false),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    isLateAllLoaded = _React$useState16[0],
    setIsLateAllLoaded = _React$useState16[1];
  var _React$useState17 = React.useState(false),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    isLateLoadingMore = _React$useState18[0],
    setIsLateLoadingMore = _React$useState18[1];
  var _React$useState19 = React.useState(false),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    isLateLoadMoreButton = _React$useState20[0],
    setIsLateLoadMoreButton = _React$useState20[1];
  var _React$useState21 = React.useState(false),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    isUninformedLeaveAllLoaded = _React$useState22[0],
    setIsUninformedLeaveAllLoaded = _React$useState22[1];
  var _React$useState23 = React.useState(false),
    _React$useState24 = _slicedToArray(_React$useState23, 2),
    isUninformedLeaveLoadingMore = _React$useState24[0],
    setIsUninformedLeaveLoadingMore = _React$useState24[1];
  var _React$useState25 = React.useState(false),
    _React$useState26 = _slicedToArray(_React$useState25, 2),
    isUninformedLeaveLoadMoreButton = _React$useState26[0],
    setIsUninformedLeaveLoadMoreButton = _React$useState26[1];
  var _React$useState27 = React.useState(false),
    _React$useState28 = _slicedToArray(_React$useState27, 2),
    isRefetching = _React$useState28[0],
    setIsRefetching = _React$useState28[1];
  var _React$useState29 = React.useState(false),
    _React$useState30 = _slicedToArray(_React$useState29, 2),
    exportButton = _React$useState30[0],
    setExportButton = _React$useState30[1];
  var _React$useState31 = React.useState(pageType == undefined ? "worked-employees" : pageType == "absent" ? "uninformed-leaves" : pageType == "late-clockin" ? "late-clock-in-employees" : "worked-employees"),
    _React$useState32 = _slicedToArray(_React$useState31, 2),
    tabData = _React$useState32[0],
    setTabData = _React$useState32[1];
  var _React$useState33 = React.useState(null),
    _React$useState34 = _slicedToArray(_React$useState33, 2),
    userParameterCheck = _React$useState34[0],
    setUserParameterCheck = _React$useState34[1];
  var _React$useState35 = React.useState(arrayToStringOutput([startDate], organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone)),
    _React$useState36 = _slicedToArray(_React$useState35, 2),
    startDateText = _React$useState36[0],
    setStartDateText = _React$useState36[1];
  React.useEffect(function () {
    if (from == "web" && role == "Member") {
      props === null || props === void 0 ? void 0 : props.history.push("/my-work");
    }
  }, [role]);
  React.useEffect(function () {
    if (((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == null || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped") && role != "Member" || organisationStatus == "inactive") {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, [organisationBilling]);
  if (pageType == "absent" || pageType == "late-clockin") {
    var newurl = "/reports/daily-attendance";
    window.history.pushState({
      path: newurl
    }, "", newurl);
  }
  var _useQuery = useQuery(USER_WORKED_LISTING_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        userRole: role,
        startDate: Number(moment(startDate).format("x")),
        endDate: Number(moment(startDate).format("x")),
        timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
      },
      skip: !organisationId
    }),
    userListData = _useQuery.data,
    userListError = _useQuery.error,
    userListLoading = _useQuery.loading;
  var _useQuery2 = useQuery(GET_DAILY_WORKED_QUERY, {
      variables: {
        organisationId: organisationId,
        userId: userParameterCheck === null || (userParameterCheck === null || userParameterCheck === void 0 ? void 0 : userParameterCheck.value) == "" ? null : userParameterCheck === null || userParameterCheck === void 0 ? void 0 : userParameterCheck.value,
        startDate: Number(moment(startDate).format("x")),
        endDate: Number(moment(startDate).format("x")),
        timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
        limit: LIMIT,
        offset: 0,
        teamId: teamId,
        userRole: role
      },
      skip: !teamId || !organisationId
    }),
    dailyAttendanceData = _useQuery2.data,
    dailyAttendanceError = _useQuery2.error,
    dailyAttendanceLoading = _useQuery2.loading,
    fetchMore = _useQuery2.fetchMore,
    dailyAttendanceRefetch = _useQuery2.refetch;

  // Tab Data Listing Query
  var _useLazyQuery = useLazyQuery(GET_DAILY_ABSENT_QUERY),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    getAbsentData = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    absentLoading = _useLazyQuery2$.loading,
    absentDataUser = _useLazyQuery2$.data,
    absentError = _useLazyQuery2$.error,
    absentFetchMore = _useLazyQuery2$.fetchMore,
    absentRefetch = _useLazyQuery2$.refetch;
  var _useLazyQuery3 = useLazyQuery(GET_DAILY_LATE_QUERY),
    _useLazyQuery4 = _slicedToArray(_useLazyQuery3, 2),
    getLateData = _useLazyQuery4[0],
    _useLazyQuery4$ = _useLazyQuery4[1],
    lateLoading = _useLazyQuery4$.loading,
    lateDataUser = _useLazyQuery4$.data,
    lateError = _useLazyQuery4$.error,
    lateFetchMore = _useLazyQuery4$.fetchMore,
    lateRefetch = _useLazyQuery4$.refetch;
  var _useLazyQuery5 = useLazyQuery(GET_UNINFORMED_LEAVE_DETAILS_QUERY),
    _useLazyQuery6 = _slicedToArray(_useLazyQuery5, 2),
    getUninformedLeaveData = _useLazyQuery6[0],
    _useLazyQuery6$ = _useLazyQuery6[1],
    uninformedLoading = _useLazyQuery6$.loading,
    uninformedDataUser = _useLazyQuery6$.data,
    uninformedError = _useLazyQuery6$.error,
    uninformedFetchMore = _useLazyQuery6$.fetchMore,
    uninformedRefetch = _useLazyQuery6$.refetch;

  // Tab User Listing Query
  var _useLazyQuery7 = useLazyQuery(USER_ABSENT_LISTING_QUERY),
    _useLazyQuery8 = _slicedToArray(_useLazyQuery7, 2),
    getUserAbsentData = _useLazyQuery8[0],
    _useLazyQuery8$ = _useLazyQuery8[1],
    userAbsentLoading = _useLazyQuery8$.loading,
    userAbsentDataUser = _useLazyQuery8$.data,
    userAbsentError = _useLazyQuery8$.error;
  var _useLazyQuery9 = useLazyQuery(USER_LATE_LISTING_QUERY),
    _useLazyQuery10 = _slicedToArray(_useLazyQuery9, 2),
    getUserLateData = _useLazyQuery10[0],
    _useLazyQuery10$ = _useLazyQuery10[1],
    userLateLoading = _useLazyQuery10$.loading,
    userLateDataUser = _useLazyQuery10$.data,
    userLateError = _useLazyQuery10$.error;
  var _useLazyQuery11 = useLazyQuery(USER_UNINFORMED_LEAVE_QUERY),
    _useLazyQuery12 = _slicedToArray(_useLazyQuery11, 2),
    getUserUninformedLeaveData = _useLazyQuery12[0],
    _useLazyQuery12$ = _useLazyQuery12[1],
    userLeaveLoading = _useLazyQuery12$.loading,
    userUninformedLeaveData = _useLazyQuery12$.data,
    userLeaveError = _useLazyQuery12$.error;

  // Export Query
  var _useLazyQuery13 = useLazyQuery(GET_DAILY_WORKED_QUERY_EXPORT, {
      // A rate-limited export (429) never returns data, and this screen's
      // spinner is cleared on data only - without this the export button
      // stays loading until the page is reloaded. The message itself is
      // shown by the errorLink in apollo/apollo-config.js.
      onError: function onError() {
        setExportButton(false);
      }
    }),
    _useLazyQuery14 = _slicedToArray(_useLazyQuery13, 2),
    getWorkedExport = _useLazyQuery14[0],
    _useLazyQuery14$ = _useLazyQuery14[1],
    workedExportLoading = _useLazyQuery14$.loading,
    workedExportData = _useLazyQuery14$.data;
  var _useLazyQuery15 = useLazyQuery(GET_DAILY_ABSENT_QUERY_EXPORT, {
      // A rate-limited export (429) never returns data, and this screen's
      // spinner is cleared on data only - without this the export button
      // stays loading until the page is reloaded. The message itself is
      // shown by the errorLink in apollo/apollo-config.js.
      onError: function onError() {
        setExportButton(false);
      }
    }),
    _useLazyQuery16 = _slicedToArray(_useLazyQuery15, 2),
    getAbsentExport = _useLazyQuery16[0],
    _useLazyQuery16$ = _useLazyQuery16[1],
    absentExportLoading = _useLazyQuery16$.loading,
    absentExportData = _useLazyQuery16$.data;
  var _useLazyQuery17 = useLazyQuery(GET_DAILY_LATE_QUERY_EXPORT, {
      // A rate-limited export (429) never returns data, and this screen's
      // spinner is cleared on data only - without this the export button
      // stays loading until the page is reloaded. The message itself is
      // shown by the errorLink in apollo/apollo-config.js.
      onError: function onError() {
        setExportButton(false);
      }
    }),
    _useLazyQuery18 = _slicedToArray(_useLazyQuery17, 2),
    getLateExport = _useLazyQuery18[0],
    _useLazyQuery18$ = _useLazyQuery18[1],
    lateExportLoading = _useLazyQuery18$.loading,
    lateExportData = _useLazyQuery18$.data;
  var _useLazyQuery19 = useLazyQuery(GET_UNINFORMED_LEAVE_DETAILS_EXPORT_QUERY, {
      // A rate-limited export (429) never returns data, and this screen's
      // spinner is cleared on data only - without this the export button
      // stays loading until the page is reloaded. The message itself is
      // shown by the errorLink in apollo/apollo-config.js.
      onError: function onError() {
        setExportButton(false);
      }
    }),
    _useLazyQuery20 = _slicedToArray(_useLazyQuery19, 2),
    getUninformedLeaveExport = _useLazyQuery20[0],
    _useLazyQuery20$ = _useLazyQuery20[1],
    leaveExportLoading = _useLazyQuery20$.loading,
    uninformedLeaveExportData = _useLazyQuery20$.data;
  var csvWorkedData = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var dataArray, dataValues, wb, ws, buf, fileName;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          dataArray = [];
          dataValues = workedExportData === null || workedExportData === void 0 ? void 0 : workedExportData.getDailyWorkedDetailsExport;
          if (dataValues) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return", []);
        case 4:
          wb = new Excel.Workbook();
          ws = wb.addWorksheet();
          ws.columns = [{
            header: "Employee Name",
            key: "user",
            width: 20,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Employee ID",
            key: "employeeId",
            width: 20,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Date",
            key: "date",
            width: 10,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Clock-In",
            key: "clockIn",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Clock-Out",
            key: "clockOut",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Duration",
            key: "totalWorkHours",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }];
          dataValues.map(function (d, index) {
            var displayName = d.displayName,
              totalWorkSec = d.totalWorkSec,
              workTime = d.workTime,
              totalWorkHours = d.totalWorkHours,
              employeeId = d.employeeId;
            var clockIn = d.clockIn,
              clockOut = d.clockOut;
            clockIn = clockIn == null || clockIn === "-" ? "--" : moment(Number(clockIn)).format("hh:mm:ss a");
            clockOut = clockOut === "-" || clockOut == null ? "--" : clockOut === "Working On" ? clockOut : moment(Number(clockOut)).format("hh:mm:ss a");
            var date = moment(startDate).local().format("DD MMM YYYY");
            ws.addRow({
              user: displayName,
              employeeId: employeeId,
              date: date,
              clockIn: clockIn,
              clockOut: clockOut,
              totalWorkHours: totalWorkHours
            });
          });
          ws.getCell("A1").font = {
            bold: true
          };
          ws.getCell("B1").font = {
            bold: true
          };
          ws.getCell("C1").font = {
            bold: true
          };
          ws.getCell("D1").font = {
            bold: true
          };
          ws.getCell("E1").font = {
            bold: true
          };
          _context.next = 15;
          return wb.xlsx.writeBuffer();
        case 15:
          buf = _context.sent;
          fileName = "workfolio-worked-employees-".concat(moment(Number(startDate)).format("DD-MMM"), ".xlsx");
          saveAs(new Blob([buf]), fileName);
          setExportButton(false);
        case 19:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [workedExportData]);
  var csvAbsentData = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var dataArray, dataValues, wb, ws, buf, fileName;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          dataArray = [];
          dataValues = absentExportData === null || absentExportData === void 0 ? void 0 : absentExportData.getDailyAbsentDetailsExport;
          if (dataValues) {
            _context2.next = 4;
            break;
          }
          return _context2.abrupt("return", []);
        case 4:
          wb = new Excel.Workbook();
          ws = wb.addWorksheet();
          ws.columns = [{
            header: "Employee Name",
            key: "user",
            width: 20,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Employee ID",
            key: "employeeId",
            width: 20,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Date",
            key: "date",
            width: 10,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Leave Type",
            key: "leaveType",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }];
          dataValues.map(function (d, index) {
            var displayName = d.displayName,
              totalWorkSec = d.totalWorkSec,
              workTime = d.workTime,
              totalWorkHours = d.totalWorkHours,
              leaveStatus = d.leaveStatus,
              employeeId = d.employeeId,
              leaveType = d.leaveType;
            var date = moment(startDate).local().format("DD MMM YYYY");
            ws.addRow({
              user: displayName,
              employeeId: employeeId,
              date: date,
              leaveType: leaveType
            });
          });
          ws.getCell("A1").font = {
            bold: true
          };
          ws.getCell("B1").font = {
            bold: true
          };
          ws.getCell("C1").font = {
            bold: true
          };
          _context2.next = 13;
          return wb.xlsx.writeBuffer();
        case 13:
          buf = _context2.sent;
          fileName = "workfolio-on-leave-employees-".concat(moment(Number(startDate)).format("DD-MMM"), ".xlsx");
          saveAs(new Blob([buf]), fileName);
          setExportButton(false);
        case 17:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })), [absentExportData]);
  var csvLateData = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var dataArray, dataValues, wb, ws, buf, fileName;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          dataArray = [];
          dataValues = lateExportData === null || lateExportData === void 0 ? void 0 : lateExportData.getLateClockInDetailsExport;
          if (dataValues) {
            _context3.next = 4;
            break;
          }
          return _context3.abrupt("return", []);
        case 4:
          wb = new Excel.Workbook();
          ws = wb.addWorksheet();
          ws.columns = [{
            header: "Employee Name",
            key: "user",
            width: 20,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Employee ID",
            key: "employeeId",
            width: 20,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Date",
            key: "date",
            width: 10,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Required",
            key: "expectedClockIn",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Clock-In",
            key: "clockIn",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Late By",
            key: "lateTime",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Clock-Out",
            key: "clockOut",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Duration",
            key: "totalWorkHours",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }];
          dataValues.map(function (d, index) {
            var displayName = d.displayName,
              totalWorkSec = d.totalWorkSec,
              workTime = d.workTime,
              totalWorkHours = d.totalWorkHours,
              expectedClockIn = d.expectedClockIn,
              lateTime = d.lateTime,
              employeeId = d.employeeId;
            var clockIn = d.clockIn,
              clockOut = d.clockOut;
            clockIn = clockIn == null || clockIn === "-" ? "--" : moment(Number(clockIn)).format("hh:mm:ss a");
            clockOut = clockOut === "-" || clockOut == null ? "--" : clockOut === "Working On" ? clockOut : moment(Number(clockOut)).format("hh:mm:ss a");
            var date = moment(startDate).local().format("DD MMM YYYY");
            ws.addRow({
              user: displayName,
              employeeId: employeeId,
              date: date,
              expectedClockIn: expectedClockIn,
              clockIn: clockIn,
              lateTime: lateTime,
              clockOut: clockOut,
              totalWorkHours: totalWorkHours
            });
          });
          ws.getCell("A1").font = {
            bold: true
          };
          ws.getCell("B1").font = {
            bold: true
          };
          ws.getCell("C1").font = {
            bold: true
          };
          ws.getCell("D1").font = {
            bold: true
          };
          ws.getCell("E1").font = {
            bold: true
          };
          ws.getCell("F1").font = {
            bold: true
          };
          ws.getCell("G1").font = {
            bold: true
          };
          _context3.next = 17;
          return wb.xlsx.writeBuffer();
        case 17:
          buf = _context3.sent;
          fileName = "workfolio-late-clock-in-".concat(moment(Number(startDate)).format("DD-MMM"), ".xlsx");
          saveAs(new Blob([buf]), fileName);
          setExportButton(false);
        case 21:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  })), [lateExportData]);
  var csvUninformedLeaveData = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var dataArray, dataValues, wb, ws, buf, fileName;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          dataArray = [];
          dataValues = uninformedLeaveExportData === null || uninformedLeaveExportData === void 0 ? void 0 : uninformedLeaveExportData.getUninformedLeaveDetailsExport;
          if (dataValues) {
            _context4.next = 4;
            break;
          }
          return _context4.abrupt("return", []);
        case 4:
          wb = new Excel.Workbook();
          ws = wb.addWorksheet();
          ws.columns = [{
            header: "Employee Name",
            key: "user",
            width: 20,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Employee ID",
            key: "employeeId",
            width: 20,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Date",
            key: "date",
            width: 10,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Status",
            key: "status",
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }];
          dataValues.map(function (d, index) {
            var displayName = d.displayName,
              employeeId = d.employeeId,
              leaveStatus = d.leaveStatus;
            var date = moment(startDate).local().format("DD MMM YYYY");
            ws.addRow({
              user: displayName,
              employeeId: employeeId,
              date: date,
              status: leaveStatus
            });
          });
          ws.getCell("A1").font = {
            bold: true
          };
          ws.getCell("B1").font = {
            bold: true
          };
          ws.getCell("C1").font = {
            bold: true
          };
          ws.getCell("D1").font = {
            bold: true
          };
          ws.getCell("E1").font = {
            bold: true
          };
          ws.getCell("F1").font = {
            bold: true
          };
          ws.getCell("G1").font = {
            bold: true
          };
          _context4.next = 17;
          return wb.xlsx.writeBuffer();
        case 17:
          buf = _context4.sent;
          fileName = "workfolio-absent-employees-".concat(moment(Number(startDate)).format("DD-MMM"), ".xlsx");
          saveAs(new Blob([buf]), fileName);
          setExportButton(false);
        case 21:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  })), [uninformedLeaveExportData]);
  React.useEffect(function () {
    csvWorkedData();
  }, [workedExportData]);
  React.useEffect(function () {
    csvAbsentData();
  }, [absentExportData]);
  React.useEffect(function () {
    csvLateData();
  }, [lateExportData]);
  React.useEffect(function () {
    csvUninformedLeaveData();
  }, [uninformedLeaveExportData]);
  React.useEffect(function () {
    setIsRefetching(true);
    dailyAttendanceRefetch === null || dailyAttendanceRefetch === void 0 ? void 0 : dailyAttendanceRefetch()["finally"](function () {
      return setIsRefetching(false);
    });
    absentRefetch === null || absentRefetch === void 0 ? void 0 : absentRefetch();
    lateRefetch === null || lateRefetch === void 0 ? void 0 : lateRefetch();
    uninformedRefetch === null || uninformedRefetch === void 0 ? void 0 : uninformedRefetch();
  }, [location.key]);
  React.useEffect(function () {
    offsets = 0;
    setIsAllLoaded(false);
    setIsLoadingMore(false);
    offsetsAbsent = 0;
    setIsAbsentAllLoaded(false);
    setIsAbsentLoadingMore(false);
    offsetsLate = 0;
    setIsLateAllLoaded(false);
    setIsLateLoadingMore(false);
    offsetsUninformed = 0;
    setIsUninformedLeaveAllLoaded(false);
    setIsUninformedLeaveLoadingMore(false);
    setStartDateText(arrayToStringOutput([startDate], organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone));
  }, [startDate]);
  React.useEffect(function () {
    if (userParameterCheck === null) {
      setUserParameterCheck({
        label: "All Employees",
        value: ""
      });
    }
  }, [userListData]);
  React.useEffect(function () {
    if (tabData === "absent-employees") {
      getAbsentData({
        variables: {
          organisationId: organisationId,
          userId: userParameterCheck === null || (userParameterCheck === null || userParameterCheck === void 0 ? void 0 : userParameterCheck.value) == "" ? null : userParameterCheck === null || userParameterCheck === void 0 ? void 0 : userParameterCheck.value,
          startDate: Number(moment(startDate).format("x")),
          endDate: Number(moment(startDate).format("x")),
          timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
          limit: ABSENT_LIMIT,
          offset: 0,
          teamId: teamId,
          userRole: role
        },
        skip: !teamId && !organisationId
      });
    } else if (tabData === "late-clock-in-employees") {
      getLateData({
        variables: {
          organisationId: organisationId,
          userId: userParameterCheck === null || (userParameterCheck === null || userParameterCheck === void 0 ? void 0 : userParameterCheck.value) == "" ? null : userParameterCheck === null || userParameterCheck === void 0 ? void 0 : userParameterCheck.value,
          startDate: Number(moment(startDate).format("x")),
          endDate: Number(moment(startDate).format("x")),
          timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
          limit: LATE_LIMIT,
          offset: 0,
          teamId: teamId,
          userRole: role
        }
      });
    } else if (tabData === "uninformed-leaves") {
      getUninformedLeaveData({
        variables: {
          organisationId: organisationId,
          userId: userParameterCheck === null || (userParameterCheck === null || userParameterCheck === void 0 ? void 0 : userParameterCheck.value) == "" ? null : userParameterCheck === null || userParameterCheck === void 0 ? void 0 : userParameterCheck.value,
          startDate: Number(moment(startDate).format("x")),
          endDate: Number(moment(startDate).format("x")),
          timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
          limit: ABSENT_LIMIT,
          offset: 0,
          teamId: teamId,
          userRole: role
        }
      });
    }
  }, [userParameterCheck, startDate]);
  React.useEffect(function () {
    if (tabData === "absent-employees") {
      getUserAbsentData({
        variables: {
          organisationId: organisationId,
          teamId: teamId,
          userRole: role,
          startDate: Number(moment(startDate).format("x")),
          endDate: Number(moment(startDate).format("x")),
          timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
        }
      });
    } else if (tabData === "late-clock-in-employees") {
      getUserLateData({
        variables: {
          organisationId: organisationId,
          teamId: teamId,
          userRole: role,
          startDate: Number(moment(startDate).format("x")),
          endDate: Number(moment(startDate).format("x")),
          timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
        }
      });
    } else if (tabData === "uninformed-leaves") {
      getUserUninformedLeaveData({
        variables: {
          organisationId: organisationId,
          teamId: teamId,
          userRole: role,
          startDate: Number(moment(startDate).format("x")),
          endDate: Number(moment(startDate).format("x")),
          timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
        }
      });
    }
  }, [startDate]);
  var getExportData = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            setExportButton(true);
            if (tabData === "worked-employees") {
              getWorkedExport({
                variables: {
                  organisationId: organisationId,
                  userId: userParameterCheck === null || (userParameterCheck === null || userParameterCheck === void 0 ? void 0 : userParameterCheck.value) == "" ? null : userParameterCheck === null || userParameterCheck === void 0 ? void 0 : userParameterCheck.value,
                  startDate: Number(moment(startDate).format("x")),
                  endDate: Number(moment(startDate).format("x")),
                  timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
                  teamId: teamId,
                  userRole: role
                }
              });
            } else if (tabData === "absent-employees") {
              getAbsentExport({
                variables: {
                  organisationId: organisationId,
                  userId: userParameterCheck === null || (userParameterCheck === null || userParameterCheck === void 0 ? void 0 : userParameterCheck.value) == "" ? null : userParameterCheck === null || userParameterCheck === void 0 ? void 0 : userParameterCheck.value,
                  startDate: Number(moment(startDate).format("x")),
                  endDate: Number(moment(startDate).format("x")),
                  timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
                  teamId: teamId,
                  userRole: role
                }
              });
            } else if (tabData === "late-clock-in-employees") {
              getLateExport({
                variables: {
                  organisationId: organisationId,
                  userId: userParameterCheck === null || (userParameterCheck === null || userParameterCheck === void 0 ? void 0 : userParameterCheck.value) == "" ? null : userParameterCheck === null || userParameterCheck === void 0 ? void 0 : userParameterCheck.value,
                  startDate: Number(moment(startDate).format("x")),
                  endDate: Number(moment(startDate).format("x")),
                  timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
                  teamId: teamId,
                  userRole: role
                }
              });
            } else if (tabData === "uninformed-leaves") {
              getUninformedLeaveExport({
                variables: {
                  organisationId: organisationId,
                  userId: userParameterCheck === null || (userParameterCheck === null || userParameterCheck === void 0 ? void 0 : userParameterCheck.value) == "" ? null : userParameterCheck === null || userParameterCheck === void 0 ? void 0 : userParameterCheck.value,
                  startDate: Number(moment(startDate).format("x")),
                  endDate: Number(moment(startDate).format("x")),
                  timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
                  teamId: teamId,
                  userRole: role
                }
              });
            }
          case 2:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function getExportData() {
      return _ref5.apply(this, arguments);
    };
  }();
  var handleLoadMore = function handleLoadMore() {
    if (dailyAttendanceLoading) return;
    setIsLoadingMore(true);
    offsets = offsets + 1;
    fetchMore({
      variables: {
        offset: offsets * LIMIT
      },
      updateQuery: function updateQuery(prev, _ref6) {
        var _fetchMoreResult$getD, _fetchMoreResult$getD2;
        var fetchMoreResult = _ref6.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$getD = fetchMoreResult.getDailyWorkedDetails) === null || _fetchMoreResult$getD === void 0 ? void 0 : _fetchMoreResult$getD.length) === 0 && ((_fetchMoreResult$getD2 = fetchMoreResult.getDailyWorkedDetails) === null || _fetchMoreResult$getD2 === void 0 ? void 0 : _fetchMoreResult$getD2.length) < LIMIT && !isAllLoaded) {
          setIsAllLoaded(true);
        }
        setIsLoadingMore(false);
        return _objectSpread(_objectSpread({}, prev), {}, {
          getDailyWorkedDetails: [].concat(_toConsumableArray(prev.getDailyWorkedDetails), _toConsumableArray(fetchMoreResult.getDailyWorkedDetails))
        });
      }
    });
  };
  var handleAbsentLoadMore = function handleAbsentLoadMore() {
    if (absentLoading) return;
    setIsAbsentLoadingMore(true);
    offsetsAbsent = offsetsAbsent + 1;
    absentFetchMore({
      variables: {
        offset: offsetsAbsent * ABSENT_LIMIT
      },
      updateQuery: function updateQuery(prev, _ref7) {
        var _fetchMoreResult$getD3, _fetchMoreResult$getD4;
        var fetchMoreResult = _ref7.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$getD3 = fetchMoreResult.getDailyAbsentDetails) === null || _fetchMoreResult$getD3 === void 0 ? void 0 : _fetchMoreResult$getD3.length) === 0 && ((_fetchMoreResult$getD4 = fetchMoreResult.getDailyAbsentDetails) === null || _fetchMoreResult$getD4 === void 0 ? void 0 : _fetchMoreResult$getD4.length) < ABSENT_LIMIT && !isAbsentAllLoaded) {
          setIsAbsentAllLoaded(true);
        }
        setIsAbsentLoadingMore(false);
        return _objectSpread(_objectSpread({}, prev), {}, {
          getDailyAbsentDetails: [].concat(_toConsumableArray(prev.getDailyAbsentDetails), _toConsumableArray(fetchMoreResult.getDailyAbsentDetails))
        });
      }
    });
  };
  var handleLateLoadMore = function handleLateLoadMore() {
    if (lateLoading) return;
    setIsLateLoadingMore(true);
    offsetsLate = offsetsLate + 1;
    lateFetchMore({
      variables: {
        offset: offsetsLate * LATE_LIMIT
      },
      updateQuery: function updateQuery(prev, _ref8) {
        var _fetchMoreResult$getL, _fetchMoreResult$getL2;
        var fetchMoreResult = _ref8.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$getL = fetchMoreResult.getLateClockInDetails) === null || _fetchMoreResult$getL === void 0 ? void 0 : _fetchMoreResult$getL.length) === 0 && ((_fetchMoreResult$getL2 = fetchMoreResult.getLateClockInDetails) === null || _fetchMoreResult$getL2 === void 0 ? void 0 : _fetchMoreResult$getL2.length) < LATE_LIMIT && !isLateAllLoaded) {
          setIsLateAllLoaded(true);
        }
        setIsLateLoadingMore(false);
        return _objectSpread(_objectSpread({}, prev), {}, {
          getLateClockInDetails: [].concat(_toConsumableArray(prev.getLateClockInDetails), _toConsumableArray(fetchMoreResult.getLateClockInDetails))
        });
      }
    });
  };
  var handleUninformedLoadMore = function handleUninformedLoadMore() {
    if (uninformedLoading) return;
    setIsUninformedLeaveLoadingMore(true);
    offsetsUninformed = offsetsUninformed + 1;
    uninformedFetchMore({
      variables: {
        offset: offsetsUninformed * UNINFORMED_LIMIT
      },
      updateQuery: function updateQuery(prev, _ref9) {
        var _fetchMoreResult$getU, _fetchMoreResult$getU2;
        var fetchMoreResult = _ref9.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$getU = fetchMoreResult.getUninformedLeaveDetails) === null || _fetchMoreResult$getU === void 0 ? void 0 : _fetchMoreResult$getU.length) === 0 && ((_fetchMoreResult$getU2 = fetchMoreResult.getUninformedLeaveDetails) === null || _fetchMoreResult$getU2 === void 0 ? void 0 : _fetchMoreResult$getU2.length) < UNINFORMED_LIMIT && !isUninformedLeaveAllLoaded) {
          setIsUninformedLeaveAllLoaded(true);
        }
        setIsUninformedLeaveLoadingMore(false);
        return _objectSpread(_objectSpread({}, prev), {}, {
          getUninformedLeaveDetails: [].concat(_toConsumableArray(prev.getUninformedLeaveDetails), _toConsumableArray(fetchMoreResult.getUninformedLeaveDetails))
        });
      }
    });
  };
  var handleTabSelect = function handleTabSelect(key) {
    setTabData(key);
    if (key === "absent-employees") {
      getUserAbsentData({
        variables: {
          organisationId: organisationId,
          teamId: teamId,
          userRole: role,
          startDate: Number(moment(startDate).format("x")),
          endDate: Number(moment(startDate).format("x")),
          timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
        }
      });
      getAbsentData({
        variables: {
          organisationId: organisationId,
          userId: userParameterCheck === null || (userParameterCheck === null || userParameterCheck === void 0 ? void 0 : userParameterCheck.value) == "" ? null : userParameterCheck === null || userParameterCheck === void 0 ? void 0 : userParameterCheck.value,
          startDate: Number(moment(startDate).format("x")),
          endDate: Number(moment(startDate).format("x")),
          timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
          limit: ABSENT_LIMIT,
          offset: 0,
          teamId: teamId,
          userRole: role
        }
      });
    } else if (key === "late-clock-in-employees") {
      getUserLateData({
        variables: {
          organisationId: organisationId,
          teamId: teamId,
          userRole: role,
          startDate: Number(moment(startDate).format("x")),
          endDate: Number(moment(startDate).format("x")),
          timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
        }
      });
      getLateData({
        variables: {
          organisationId: organisationId,
          userId: userParameterCheck === null || (userParameterCheck === null || userParameterCheck === void 0 ? void 0 : userParameterCheck.value) == "" ? null : userParameterCheck === null || userParameterCheck === void 0 ? void 0 : userParameterCheck.value,
          startDate: Number(moment(startDate).format("x")),
          endDate: Number(moment(startDate).format("x")),
          timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
          limit: LATE_LIMIT,
          offset: 0,
          teamId: teamId,
          userRole: role
        }
      });
    } else if (key === "uninformed-leaves") {
      getUserUninformedLeaveData({
        variables: {
          organisationId: organisationId,
          teamId: teamId,
          userRole: role,
          startDate: Number(moment(startDate).format("x")),
          endDate: Number(moment(startDate).format("x")),
          timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
        }
      });
      getUninformedLeaveData({
        variables: {
          organisationId: organisationId,
          userId: userParameterCheck === null || (userParameterCheck === null || userParameterCheck === void 0 ? void 0 : userParameterCheck.value) == "" ? null : userParameterCheck === null || userParameterCheck === void 0 ? void 0 : userParameterCheck.value,
          startDate: Number(moment(startDate).format("x")),
          endDate: Number(moment(startDate).format("x")),
          timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
          limit: ABSENT_LIMIT,
          offset: 0,
          teamId: teamId,
          userRole: role
        }
      });
    }
    setUserParameterCheck({
      label: "All Employees",
      value: ""
    });
  };
  var clockInStatus = checkExpectedClockInReached(organisationSettings);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "daily-attendance-tab-new-root"
  }, /*#__PURE__*/React.createElement(Tabs, {
    defaultActiveKey: pageType == undefined ? "worked-employees" : pageType == "absent" ? "uninformed-leaves" : pageType == "late-clockin" ? "late-clock-in-employees" : "worked-employees",
    onSelect: function onSelect(e) {
      handleTabSelect(e);
    },
    className: "daily-attendance-filter-root-tab"
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "worked-employees",
    title: "Worked Employees"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabFilter, {
    userParameterCheck: userParameterCheck,
    setUserParameterCheck: setUserParameterCheck,
    userListData: userListData === null || userListData === void 0 ? void 0 : userListData.getUserListingForWorked,
    setStartDate: setStartDate,
    startDate: startDate,
    organisationBilling: organisationBilling,
    exportButton: exportButton,
    getExportData: getExportData,
    userListLoading: userListLoading,
    userListError: userListError,
    isLoading: dailyAttendanceLoading || isRefetching
  }), dailyAttendanceLoading || isRefetching ? /*#__PURE__*/React.createElement(Loader, null) : dailyAttendanceError ? /*#__PURE__*/React.createElement("div", {
    className: "common-err-refresh-text"
  }, "Something went wrong, please refresh the page.") : !dailyAttendanceData ? /*#__PURE__*/React.createElement("div", null, "No data") : /*#__PURE__*/React.createElement(WorkedTab, {
    userParameterCheck: userParameterCheck,
    startDate: startDate,
    dailyAttendanceData: dailyAttendanceData,
    handleLoadMore: handleLoadMore,
    setIsAllLoaded: setIsAllLoaded,
    isAllLoaded: isAllLoaded,
    isLoadingMore: isLoadingMore,
    isLoadMoreButton: isLoadMoreButton,
    tabData: tabData,
    Link: Link,
    linkProps: linkProps,
    timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
  }))), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "late-clock-in-employees",
    title: "Late Clock In Employees"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabFilter, {
    userParameterCheck: userParameterCheck,
    setUserParameterCheck: setUserParameterCheck,
    userListData: userLateDataUser === null || userLateDataUser === void 0 ? void 0 : userLateDataUser.getUserListingForLate,
    setStartDate: setStartDate,
    startDate: startDate,
    organisationBilling: organisationBilling,
    exportButton: exportButton,
    getExportData: getExportData,
    userListLoading: userLateLoading,
    userListError: userLateError
  }), (!(organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.expectedClockInTime) || (organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.expectedClockInTime) == null) && (organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.userExpectedClockInStatus) == "false" ? /*#__PURE__*/React.createElement("div", {
    className: "daily-enable-expected-clockin-track-settings"
  }, /*#__PURE__*/React.createElement("div", {
    className: "overview-enable-expected-clockin-track-settings-text"
  }, " ", "Set the expected clock-in time to get the live report"), /*#__PURE__*/React.createElement("div", {
    className: "overview-enable-expected-clockin-track-settings-steps"
  }, /*#__PURE__*/React.createElement("div", {
    className: "overview-enable-expected-clockin-track-settings-steps-title"
  }, "Here are the steps to set the expected clock-in time:"), /*#__PURE__*/React.createElement("div", {
    className: "overview-enable-expected-clockin-track-settings-steps-title-1"
  }, "1. Visit Settings -> Track Settings page", " "), /*#__PURE__*/React.createElement("div", {
    className: "overview-enable-expected-clockin-track-settings-steps-title-2"
  }, "2. Set the expected clock-in time", " "), /*#__PURE__*/React.createElement("div", {
    className: "overview-enable-expected-clockin-track-settings-steps-title-3"
  }, "3. Optionally, you can set the person-wise expected clock-in time", " ", /*#__PURE__*/React.createElement("a", {
    href: "https://workfolio.tawk.help/article/how-to-set-the-person-wise-expected-clock-in-time",
    className: "overview-enable-expected-clockin-track-settings-know-more-link",
    target: "_blank"
  }, "(know more)")))) : lateLoading ? /*#__PURE__*/React.createElement(Loader, null) : lateError ? /*#__PURE__*/React.createElement("div", {
    className: "common-err-refresh-text"
  }, "Something went wrong, please refresh the page.") : lateDataUser && (lateDataUser === null || lateDataUser === void 0 ? void 0 : lateDataUser.getLateClockInDetails.length) != 0 || clockInStatus || startDateText != "Today" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LateTab, {
    userParameterCheck: userParameterCheck,
    startDate: startDate,
    lateDataUser: lateDataUser,
    handleLateLoadMore: handleLateLoadMore,
    setIsLateAllLoaded: setIsLateAllLoaded,
    isLateAllLoaded: isLateAllLoaded,
    isLateLoadingMore: isLateLoadingMore,
    isLateLoadMoreButton: isLateLoadMoreButton,
    tabData: tabData,
    timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
  })) : !clockInStatus && startDateText == "Today" ? /*#__PURE__*/React.createElement("div", {
    className: "daily-enable-expected-clockin-track-settings"
  }, "Your expected clock-in time is ".concat(moment(organisationSettings.expectedClockInTime).tz(organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone).format("HH:mm A"), ", after that you can see the leave employees")) : null)), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "absent-employees",
    title: "On Leave Employees"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabFilter, {
    userParameterCheck: userParameterCheck,
    setUserParameterCheck: setUserParameterCheck,
    userListData: userAbsentDataUser === null || userAbsentDataUser === void 0 ? void 0 : userAbsentDataUser.getUserListingForAbsent,
    setStartDate: setStartDate,
    startDate: startDate,
    organisationBilling: organisationBilling,
    exportButton: exportButton,
    getExportData: getExportData,
    userListLoading: userAbsentLoading,
    userListError: userAbsentError
  }),
  // (!organisationSettings.expectedClockInTime || organisationSettings.expectedClockInTime == null) &&
  // organisationSettings?.userExpectedClockInStatus == "false" ? (
  //   <div className="daily-enable-expected-clockin-track-settings">
  //     <div className="overview-enable-expected-clockin-track-settings-text">
  //       {" "}
  //       Set the expected clock-in time to get the live report
  //     </div>
  //     <div className="overview-enable-expected-clockin-track-settings-steps">
  //       <div className="overview-enable-expected-clockin-track-settings-steps-title">
  //         Here are the steps to set the expected clock-in time:
  //       </div>
  //       <div className="overview-enable-expected-clockin-track-settings-steps-title-1">
  //         {"1. Visit Settings -> Track Settings page"}{" "}
  //       </div>
  //       <div className="overview-enable-expected-clockin-track-settings-steps-title-2">
  //         2. Set the expected clock-in time{" "}
  //       </div>
  //       <div className="overview-enable-expected-clockin-track-settings-steps-title-3">
  //         3. Optionally, you can set the person-wise expected clock-in time{" "}
  //         <a
  //           href="https://workfolio.tawk.help/article/how-to-set-the-person-wise-expected-clock-in-time"
  //           className="overview-enable-expected-clockin-track-settings-know-more-link"
  //           target="_blank"
  //         >
  //           (know more)
  //         </a>
  //       </div>
  //     </div>
  //   </div>
  // ) :
  absentLoading ? /*#__PURE__*/React.createElement(Loader, null) : absentError ? /*#__PURE__*/React.createElement("div", {
    className: "common-err-refresh-text"
  }, "Something went wrong, please refresh the page.") : (absentDataUser === null || absentDataUser === void 0 ? void 0 : (_absentDataUser$getDa = absentDataUser.getDailyAbsentDetails) === null || _absentDataUser$getDa === void 0 ? void 0 : _absentDataUser$getDa.length) == 0 ? /*#__PURE__*/React.createElement("div", null, "No data") : absentDataUser && (absentDataUser === null || absentDataUser === void 0 ? void 0 : (_absentDataUser$getDa2 = absentDataUser.getDailyAbsentDetails) === null || _absentDataUser$getDa2 === void 0 ? void 0 : _absentDataUser$getDa2.length) != 0 || clockInStatus || startDateText != "Today" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AbsentTab, {
    userParameterCheck: userParameterCheck,
    startDate: startDate,
    absentDataUser: absentDataUser,
    handleAbsentLoadMore: handleAbsentLoadMore,
    setIsAbsentAllLoaded: setIsAbsentAllLoaded,
    isAbsentAllLoaded: isAbsentAllLoaded,
    isAbsentLoadingMore: isAbsentLoadingMore,
    isAbsentLoadMoreButton: isAbsentLoadMoreButton,
    tabData: tabData,
    timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
  })) : !clockInStatus && startDateText == "Today" ? /*#__PURE__*/React.createElement("div", {
    className: "daily-enable-expected-clockin-track-settings"
  }, "Your expected clock-in time is ".concat(moment(organisationSettings.expectedClockInTime).tz(organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone).format("HH:mm A"), ", after that you can see the leave employees")) : null)), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "uninformed-leaves",
    title: "Absent Employees"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabFilter, {
    userParameterCheck: userParameterCheck,
    setUserParameterCheck: setUserParameterCheck,
    userListData: userUninformedLeaveData === null || userUninformedLeaveData === void 0 ? void 0 : userUninformedLeaveData.getUserUninformedLeave,
    setStartDate: setStartDate,
    startDate: startDate,
    organisationBilling: organisationBilling,
    exportButton: exportButton,
    getExportData: getExportData,
    userListLoading: userLeaveLoading,
    userListError: userLeaveError
  }), (!organisationSettings.expectedClockInTime || organisationSettings.expectedClockInTime == null) && (organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.userExpectedClockInStatus) == "false" && startDateText != "Today" ? /*#__PURE__*/React.createElement("div", {
    className: "daily-enable-expected-clockin-track-settings"
  }, /*#__PURE__*/React.createElement("div", {
    className: "overview-enable-expected-clockin-track-settings-text"
  }, " ", "Set the expected clock-in time to get the live report"), /*#__PURE__*/React.createElement("div", {
    className: "overview-enable-expected-clockin-track-settings-steps"
  }, /*#__PURE__*/React.createElement("div", {
    className: "overview-enable-expected-clockin-track-settings-steps-title"
  }, "Here are the steps to set the expected clock-in time:"), /*#__PURE__*/React.createElement("div", {
    className: "overview-enable-expected-clockin-track-settings-steps-title-1"
  }, "1. Visit Settings -> Track Settings page", " "), /*#__PURE__*/React.createElement("div", {
    className: "overview-enable-expected-clockin-track-settings-steps-title-2"
  }, "2. Set the expected clock-in time", " "))) : clockInStatus || startDateText != "Today" ? uninformedLoading ? /*#__PURE__*/React.createElement(Loader, null) : uninformedError ? /*#__PURE__*/React.createElement("div", {
    className: "common-err-refresh-text"
  }, "Something went wrong, please refresh the page.") : !uninformedDataUser ? /*#__PURE__*/React.createElement("div", null, "No data") : /*#__PURE__*/React.createElement(UninformedTab, {
    userParameterCheck: userParameterCheck,
    startDate: startDate,
    uninformedDataUser: uninformedDataUser,
    handleUninformedLoadMore: handleUninformedLoadMore,
    setIsUninformedLeaveAllLoaded: setIsUninformedLeaveAllLoaded,
    isUninformedLeaveAllLoaded: isUninformedLeaveAllLoaded,
    isUninformedLeaveLoadingMore: isUninformedLeaveLoadingMore,
    isUninformedLeaveLoadMoreButton: isUninformedLeaveLoadMoreButton,
    tabData: tabData,
    timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
  }) : !clockInStatus && startDateText == "Today" ? /*#__PURE__*/React.createElement("div", {
    className: "daily-enable-expected-clockin-track-settings"
  }, "Your expected clock-in time is ".concat(moment(organisationSettings.expectedClockInTime).tz(organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone).format("HH:mm A"), ", after that you can see the leave employees")) : null))))));
};
var TabFilter = function TabFilter(props) {
  var userParameterCheck = props.userParameterCheck,
    setUserParameterCheck = props.setUserParameterCheck,
    userListData = props.userListData,
    setStartDate = props.setStartDate,
    startDate = props.startDate,
    organisationBilling = props.organisationBilling,
    exportButton = props.exportButton,
    getExportData = props.getExportData,
    userListLoading = props.userListLoading,
    userListError = props.userListError,
    isLoading = props.isLoading;
  return /*#__PURE__*/React.createElement("div", {
    className: "daily-attendance-filter-new-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "daily-attendance-filter-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "daily-attendance-filter-user"
  }, /*#__PURE__*/React.createElement(Select, {
    value: userParameterCheck,
    onChange: function onChange(e) {
      return setUserParameterCheck(e);
    },
    options: userListData,
    className: "daily-attendance-filter-user-select",
    classNamePrefix: "Filter By User",
    isLoading: userListLoading,
    loadingMessage: function loadingMessage() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, "Loading...");
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "daily-attendance-date-picker"
  }, " ", /*#__PURE__*/React.createElement(DatePicker, {
    selected: startDate,
    onChange: function onChange(date) {
      return setStartDate(date);
    },
    dateFormat: "dd MMM, yyyy",
    minDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" ? subDays(new Date(), 14) : null,
    disabled: isLoading
  }))), /*#__PURE__*/React.createElement("div", null, (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) != "free" ? !exportButton ? /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      getExportData();
    },
    className: "daily-attendance-filter-download-icon-btn"
  }, /*#__PURE__*/React.createElement(HiDownload, {
    className: "daily-attendance-filter-download-icon"
  }), " Export") : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    className: "daily-attendance-filter-download-icon-btn"
  }, /*#__PURE__*/React.createElement(HiDownload, {
    className: "daily-attendance-filter-download-icon"
  }), "Downloading") : /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade your plan to export report")
  }, /*#__PURE__*/React.createElement("div", {
    className: "timesheet-export-button-header disable-timesheet"
  }, /*#__PURE__*/React.createElement(HiDownload, {
    className: "timesheet-download-icon"
  }), " Export"))));
};
var WorkedTab = function WorkedTab(props) {
  var _dailyAttendanceData$, _dailyAttendanceData$2, _dailyAttendanceData$3;
  var userParameterCheck = props.userParameterCheck,
    startDate = props.startDate,
    setIsAllLoaded = props.setIsAllLoaded,
    isAllLoaded = props.isAllLoaded,
    isLoadingMore = props.isLoadingMore,
    isLoadMoreButton = props.isLoadMoreButton,
    dailyAttendanceData = props.dailyAttendanceData,
    handleLoadMore = props.handleLoadMore,
    tabData = props.tabData,
    Link = props.Link,
    linkProps = props.linkProps,
    timeZone = props.timeZone;
  var columns = React.useMemo(function () {
    return [{
      Header: "Employee Name",
      accessor: "displayName"
    }, {
      Header: "Date",
      accessor: "date"
    }, {
      Header: "Clock-In",
      accessor: "clockIn"
    }, {
      Header: "Clock-Out",
      accessor: "clockOut"
    }, {
      Header: "Duration",
      accessor: "totalWorkHours"
    }
    // {
    //   Header: "Work Time",
    //   accessor: "workTime",
    // },
    ];
  }, []);
  if (!dailyAttendanceData) {
    return null;
  }
  var dataTable = dailyAttendanceData === null || dailyAttendanceData === void 0 ? void 0 : (_dailyAttendanceData$ = dailyAttendanceData.getDailyWorkedDetails) === null || _dailyAttendanceData$ === void 0 ? void 0 : _dailyAttendanceData$.map(function (d) {
    var displayName = d.displayName,
      totalWorkHours = d.totalWorkHours,
      workTime = d.workTime,
      employeeId = d.employeeId,
      uniqueUrl = d.uniqueUrl,
      userId = d.userId,
      profileUrl = d.profileUrl;
    var clockIn = d.clockIn,
      clockOut = d.clockOut;
    clockIn = clockIn == null || clockIn === "-" ? "--" : moment(Number(clockIn)).format("hh:mm:ss a");
    clockOut = clockOut == null || clockOut === "-" ? "--" : clockOut === "Working On" ? clockOut : moment(Number(clockOut)).format("hh:mm:ss a");
    //const date = moment(startDate).tz(timeZone).format("DD MMM YYYY");
    var date = moment(startDate).local().format("DD MMM YYYY");
    return {
      displayName: displayName,
      totalWorkHours: totalWorkHours,
      clockIn: clockIn,
      clockOut: clockOut,
      // workTime,
      date: date,
      employeeId: employeeId,
      uniqueUrl: uniqueUrl,
      userId: userId,
      profileUrl: profileUrl
    };
  });
  if ((dailyAttendanceData === null || dailyAttendanceData === void 0 ? void 0 : (_dailyAttendanceData$2 = dailyAttendanceData.getDailyWorkedDetails) === null || _dailyAttendanceData$2 === void 0 ? void 0 : _dailyAttendanceData$2.length) !== 0 && (dailyAttendanceData === null || dailyAttendanceData === void 0 ? void 0 : (_dailyAttendanceData$3 = dailyAttendanceData.getDailyWorkedDetails) === null || _dailyAttendanceData$3 === void 0 ? void 0 : _dailyAttendanceData$3.length) < LIMIT && !isAllLoaded) {
    setIsAllLoaded(true);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, (dailyAttendanceData === null || dailyAttendanceData === void 0 ? void 0 : dailyAttendanceData.getDailyWorkedDetails.length) !== 0 ? /*#__PURE__*/React.createElement(TableGrid, {
    columns: columns,
    data: dataTable,
    handleLoadMore: handleLoadMore,
    isAllLoaded: isAllLoaded,
    isLoadingMore: isLoadingMore,
    isLoadMoreButton: isLoadMoreButton,
    userParameterCheck: userParameterCheck,
    tabData: tabData,
    Link: Link,
    linkProps: linkProps
  }) : /*#__PURE__*/React.createElement("div", {
    className: "daily-no-data-tab"
  }, " No data"));
};
var AbsentTab = function AbsentTab(props) {
  var _absentDataUser$getDa3, _absentDataUser$getDa4, _absentDataUser$getDa5, _absentDataUser$getDa6;
  var userParameterCheck = props.userParameterCheck,
    startDate = props.startDate,
    setIsAbsentAllLoaded = props.setIsAbsentAllLoaded,
    isAbsentAllLoaded = props.isAbsentAllLoaded,
    isAbsentLoadingMore = props.isAbsentLoadingMore,
    isAbsentLoadMoreButton = props.isAbsentLoadMoreButton,
    absentDataUser = props.absentDataUser,
    handleAbsentLoadMore = props.handleAbsentLoadMore,
    tabData = props.tabData,
    timeZone = props.timeZone;
  var columns = React.useMemo(function () {
    return [{
      Header: "Employee Name",
      accessor: "leaveDisplayName"
    }, {
      Header: "Date",
      accessor: "leaveDate"
    }, {
      Header: "Leave Type",
      accessor: "leaveType"
    }];
  }, []);
  if (!absentDataUser) {
    return null;
  }
  var dataTable = absentDataUser === null || absentDataUser === void 0 ? void 0 : (_absentDataUser$getDa3 = absentDataUser.getDailyAbsentDetails) === null || _absentDataUser$getDa3 === void 0 ? void 0 : _absentDataUser$getDa3.map(function (d) {
    var displayName = d.displayName,
      totalWorkHours = d.totalWorkHours,
      workTime = d.workTime,
      leaveStatus = d.leaveStatus,
      employeeId = d.employeeId,
      profileUrl = d.profileUrl,
      leaveType = d.leaveType;
    var date = moment(startDate).local().format("DD MMM YYYY");
    return {
      leaveDisplayName: displayName,
      leaveDate: date,
      leaveType: leaveType,
      employeeId: employeeId,
      profileUrl: profileUrl
    };
  });
  if ((absentDataUser === null || absentDataUser === void 0 ? void 0 : (_absentDataUser$getDa4 = absentDataUser.getDailyAbsentDetails) === null || _absentDataUser$getDa4 === void 0 ? void 0 : _absentDataUser$getDa4.length) !== 0 && (absentDataUser === null || absentDataUser === void 0 ? void 0 : (_absentDataUser$getDa5 = absentDataUser.getDailyAbsentDetails) === null || _absentDataUser$getDa5 === void 0 ? void 0 : _absentDataUser$getDa5.length) < ABSENT_LIMIT && !isAbsentAllLoaded) {
    setIsAbsentAllLoaded(true);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, (absentDataUser === null || absentDataUser === void 0 ? void 0 : (_absentDataUser$getDa6 = absentDataUser.getDailyAbsentDetails) === null || _absentDataUser$getDa6 === void 0 ? void 0 : _absentDataUser$getDa6.length) !== 0 ? /*#__PURE__*/React.createElement(TableGrid, {
    columns: columns,
    data: dataTable,
    handleLoadMore: handleAbsentLoadMore,
    isAllLoaded: isAbsentAllLoaded,
    isLoadingMore: isAbsentLoadingMore,
    isLoadMoreButton: isAbsentLoadMoreButton,
    userParameterCheck: userParameterCheck,
    tabData: tabData
  }) : /*#__PURE__*/React.createElement("div", {
    className: "daily-no-data-tab"
  }, " No data"));
};
var LateTab = function LateTab(props) {
  var _lateDataUser$getLate, _lateDataUser$getLate2, _lateDataUser$getLate3, _lateDataUser$getLate4;
  var userParameterCheck = props.userParameterCheck,
    startDate = props.startDate,
    setIsLateAllLoaded = props.setIsLateAllLoaded,
    isLateAllLoaded = props.isLateAllLoaded,
    isLateLoadingMore = props.isLateLoadingMore,
    isLateLoadMoreButton = props.isLateLoadMoreButton,
    lateDataUser = props.lateDataUser,
    handleLateLoadMore = props.handleLateLoadMore,
    tabData = props.tabData,
    timeZone = props.timeZone;
  var columns = React.useMemo(function () {
    return [{
      Header: "Employee Name",
      accessor: "displayName"
    }, {
      Header: "Date",
      accessor: "date"
    }, {
      Header: "Required",
      accessor: "expectedClockIn"
    }, {
      Header: "Clock-In",
      accessor: "clockIn"
    }, {
      Header: "Late By",
      accessor: "lateTime"
    }, {
      Header: "Clock-Out",
      accessor: "clockOut"
    }, {
      Header: "Duration",
      accessor: "totalWorkHours"
    }
    // {
    //   Header: "Work Time",
    //   accessor: "workTime",
    // },
    ];
  }, []);
  if (!lateDataUser) {
    return null;
  }
  var dataTable = lateDataUser === null || lateDataUser === void 0 ? void 0 : (_lateDataUser$getLate = lateDataUser.getLateClockInDetails) === null || _lateDataUser$getLate === void 0 ? void 0 : _lateDataUser$getLate.map(function (d) {
    var displayName = d.displayName,
      totalWorkHours = d.totalWorkHours,
      workTime = d.workTime,
      lateTime = d.lateTime,
      expectedClockIn = d.expectedClockIn,
      employeeId = d.employeeId,
      profileUrl = d.profileUrl;
    var clockIn = d.clockIn,
      clockOut = d.clockOut;
    clockIn = clockIn == null || clockIn === "-" ? "--" : moment(Number(clockIn)).format("hh:mm:ss a");
    clockOut = clockOut == null || clockOut === "-" ? "--" : clockOut === "Working On" ? clockOut : moment(Number(clockOut)).format("hh:mm:ss a");
    var date = moment(startDate).local().format("DD MMM YYYY");
    return {
      displayName: displayName,
      totalWorkHours: totalWorkHours,
      expectedClockIn: expectedClockIn,
      clockIn: clockIn,
      lateTime: lateTime,
      clockOut: clockOut,
      // workTime,
      date: date,
      employeeId: employeeId,
      profileUrl: profileUrl
    };
  });
  if ((lateDataUser === null || lateDataUser === void 0 ? void 0 : (_lateDataUser$getLate2 = lateDataUser.getLateClockInDetails) === null || _lateDataUser$getLate2 === void 0 ? void 0 : _lateDataUser$getLate2.length) !== 0 && (lateDataUser === null || lateDataUser === void 0 ? void 0 : (_lateDataUser$getLate3 = lateDataUser.getLateClockInDetails) === null || _lateDataUser$getLate3 === void 0 ? void 0 : _lateDataUser$getLate3.length) < LIMIT && !isLateAllLoaded) {
    setIsLateAllLoaded(true);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, (lateDataUser === null || lateDataUser === void 0 ? void 0 : (_lateDataUser$getLate4 = lateDataUser.getLateClockInDetails) === null || _lateDataUser$getLate4 === void 0 ? void 0 : _lateDataUser$getLate4.length) !== 0 ? /*#__PURE__*/React.createElement(TableGrid, {
    columns: columns,
    data: dataTable,
    handleLoadMore: handleLateLoadMore,
    isAllLoaded: isLateAllLoaded,
    isLoadingMore: isLateLoadingMore,
    isLoadMoreButton: isLateLoadMoreButton,
    userParameterCheck: userParameterCheck,
    tabData: tabData
  }) : /*#__PURE__*/React.createElement("div", {
    className: "daily-no-data-tab"
  }, " No data"));
};
var TableGrid = function TableGrid(props) {
  var columns = props.columns,
    data = props.data,
    handleLoadMore = props.handleLoadMore,
    isAllLoaded = props.isAllLoaded,
    isLoadingMore = props.isLoadingMore,
    isLoadMoreButton = props.isLoadMoreButton,
    userParameterCheck = props.userParameterCheck,
    tabData = props.tabData,
    Link = props.Link,
    linkProps = props.linkProps;
  var _useTable = useTable({
      columns: columns,
      data: data
    }, useSortBy),
    getTableProps = _useTable.getTableProps,
    getTableBodyProps = _useTable.getTableBodyProps,
    headerGroups = _useTable.headerGroups,
    rows = _useTable.rows,
    prepareRow = _useTable.prepareRow;
  return /*#__PURE__*/React.createElement("div", {
    className: "daily-attendance-content-new"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("table", _extends({}, getTableProps(), {
    className: "".concat(tabData === "absent-employees" ? "daily-attendance-absent-table" : "daily-attendance-table")
  }), /*#__PURE__*/React.createElement("thead", null, headerGroups.map(function (headerGroup) {
    return /*#__PURE__*/React.createElement("tr", headerGroup.getHeaderGroupProps(), headerGroup.headers.map(function (column) {
      // Add the sorting props to control sorting. For this example
      // we can add them into the header props
      //console.log("column", column);
      return /*#__PURE__*/React.createElement("th", column.getHeaderProps(column.getSortByToggleProps()), column.render("Header"), /*#__PURE__*/React.createElement("span", null, column.isSorted ? column.isSortedDesc ? /*#__PURE__*/React.createElement(HiChevronUp, {
        className: "app-usage-datas-thead-sort-icon"
      }) : /*#__PURE__*/React.createElement(HiChevronDown, {
        className: "app-usage-datas-thead-sort-icon"
      }) : /*#__PURE__*/React.createElement(HiOutlineSelector, {
        className: "app-usage-datas-thead-sort-icon"
      })));
    }));
  })), /*#__PURE__*/React.createElement("tbody", getTableBodyProps(), rows.map(function (row, i) {
    prepareRow(row);
    return /*#__PURE__*/React.createElement("tr", row.getRowProps(), row.cells.map(function (cell) {
      var leaveStatusClassName = "daily-attendance-tr-table-leave-status-".concat(cell.value == "Approved Leave" ? "approved" : "uninformed");
      return /*#__PURE__*/React.createElement("td", _extends({
        className: "".concat(cell.column.id === "status" || cell.column.id === "leaveDate" || cell.column.id === "leaveStatus" ? "daily-attendance-tr-table-grid-staus" : cell.column.id === "leaveDisplayName" ? "daily-attendance-tr-table-grid-leave-name" : "", " ").concat(cell.column.id == "leaveStatus" ? leaveStatusClassName : "")
      }, cell.getCellProps()), cell.column.id === "displayName" || cell.column.id === "leaveDisplayName" ? /*#__PURE__*/React.createElement("div", {
        className: "daily-attendance-tr-table-grid-employee-displayname-wrapper"
      }, cell.row.original.profileUrl ? /*#__PURE__*/React.createElement("div", {
        "class": "monthly-in-out-table-avatar-profile"
      }, /*#__PURE__*/React.createElement("img", {
        alt: "Workfolio",
        src: cell.row.original.profileUrl,
        "class": "monthly-in-out-table-card-avatar-profile-img"
      })) : /*#__PURE__*/React.createElement("div", {
        className: "daily-attendance-tr-table-grid-employee-avatar-circle text-white"
      }, cell.value.charAt(0)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: !cell.row.original.employeeId ? "daily-attendance-tr-table-grid-employee-name" : ""
      }, cell.value), cell.row.original.employeeId ? /*#__PURE__*/React.createElement("div", {
        className: "daily-attendance-tr-table-grid-employee-id"
      }, "Emp ID: ", cell.row.original.employeeId) : "")) : cell.render("Cell"));
    }));
  }), tabData == "uninformed-leaves" ? !isAllLoaded ? /*#__PURE__*/React.createElement(React.Fragment, null, isLoadingMore && !isLoadMoreButton ? /*#__PURE__*/React.createElement("tr", {
    className: "daily-attendance-table-load-more-tr"
  }, /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", {
    colSpan: 1,
    className: "daily-attendance-table-load-more-td"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null))), /*#__PURE__*/React.createElement("td", null)) : /*#__PURE__*/React.createElement("tr", {
    className: "daily-attendance-table-load-more-tr"
  }, /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", {
    colSpan: 1,
    className: "daily-attendance-table-load-more-td"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      handleLoadMore();
    },
    className: "daily-attendance-table-load-more-btn"
  }, "Load more")), /*#__PURE__*/React.createElement("td", null))) : (userParameterCheck === null || userParameterCheck === void 0 ? void 0 : userParameterCheck.label) === "All Member" ? /*#__PURE__*/React.createElement("tr", {
    className: "daily-attendance-table-load-more-tr"
  }, /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", {
    colSpan: 1,
    className: "daily-attendance-table-load-more-td"
  }, /*#__PURE__*/React.createElement("p", {
    className: "screenshot-load-more-button"
  }, "You have seen all the member")), /*#__PURE__*/React.createElement("td", null)) : null : tabData !== "absent-employees" && tabData !== "late-clock-in-employees" ? !isAllLoaded ? /*#__PURE__*/React.createElement(React.Fragment, null, isLoadingMore && !isLoadMoreButton ? /*#__PURE__*/React.createElement("tr", {
    className: "daily-attendance-table-load-more-tr"
  }, /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", {
    colSpan: 6,
    className: "daily-attendance-table-load-more-td"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null))), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null)) : /*#__PURE__*/React.createElement("tr", {
    className: "daily-attendance-table-load-more-tr"
  }, /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", {
    colSpan: 6,
    className: "daily-attendance-table-load-more-td"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      handleLoadMore();
    },
    className: "daily-attendance-table-load-more-btn"
  }, "Load more")), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null))) : (userParameterCheck === null || userParameterCheck === void 0 ? void 0 : userParameterCheck.label) === "All Member" ? /*#__PURE__*/React.createElement("tr", {
    className: "daily-attendance-table-load-more-tr"
  }, /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", {
    colSpan: 6,
    className: "daily-attendance-table-load-more-td"
  }, /*#__PURE__*/React.createElement("p", {
    className: "screenshot-load-more-button"
  }, "You have seen all the member")), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null)) : null : !isAllLoaded && tabData !== "absent-employees" && tabData !== "late-clock-in-employees" ? /*#__PURE__*/React.createElement(React.Fragment, null, isLoadingMore && !isLoadMoreButton ? /*#__PURE__*/React.createElement("tr", {
    className: "daily-attendance-table-load-more-tr"
  }, /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", {
    colSpan: 2,
    className: "daily-attendance-table-load-more-td"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null))), /*#__PURE__*/React.createElement("td", null)) : /*#__PURE__*/React.createElement("tr", {
    className: "daily-attendance-table-load-more-tr"
  }, /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", {
    colSpan: 2,
    className: "daily-attendance-table-load-more-td"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      handleLoadMore();
    },
    className: "daily-attendance-table-load-more-btn"
  }, "Load more")), /*#__PURE__*/React.createElement("td", null))) : (userParameterCheck === null || userParameterCheck === void 0 ? void 0 : userParameterCheck.label) === "All Member" || tabData == "absent-employees" ? /*#__PURE__*/React.createElement("tr", {
    className: "daily-attendance-table-load-more-tr"
  }, /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", {
    colSpan: 6,
    className: "daily-attendance-table-load-more-td"
  }, /*#__PURE__*/React.createElement("p", {
    className: "screenshot-load-more-button"
  }, "You have seen all the member")), /*#__PURE__*/React.createElement("td", null)) : null))));
};
export var gridData = [{
  user: "Leanne Graham",
  punchIn: "08/01/2022 12:16 pm",
  punchOut: "--",
  punchDuration: "00:34:07",
  workTime: "SHORT TIME"
}, {
  user: "Leanne Graham",
  punchIn: "09/01/2022 01:10 pm",
  punchOut: "--",
  punchDuration: "00:90:07",
  workTime: "SHORT TIME"
}];
var UninformedTab = function UninformedTab(props) {
  var _uninformedDataUser$g, _uninformedDataUser$g2, _uninformedDataUser$g3, _uninformedDataUser$g4;
  var userParameterCheck = props.userParameterCheck,
    startDate = props.startDate,
    setIsUninformedLeaveAllLoaded = props.setIsUninformedLeaveAllLoaded,
    isUninformedLeaveAllLoaded = props.isUninformedLeaveAllLoaded,
    isUninformedLeaveLoadingMore = props.isUninformedLeaveLoadingMore,
    isUninformedLeaveLoadMoreButton = props.isUninformedLeaveLoadMoreButton,
    uninformedDataUser = props.uninformedDataUser,
    handleUninformedLoadMore = props.handleUninformedLoadMore,
    tabData = props.tabData,
    timeZone = props.timeZone;
  var columns = React.useMemo(function () {
    return [{
      Header: "Employee Name",
      accessor: "displayName"
    }, {
      Header: "Date",
      accessor: "date"
    }, {
      Header: "Status",
      accessor: "status"
    }];
  }, []);
  if (!uninformedDataUser) {
    return null;
  }
  var dataTable = uninformedDataUser === null || uninformedDataUser === void 0 ? void 0 : (_uninformedDataUser$g = uninformedDataUser.getUninformedLeaveDetails) === null || _uninformedDataUser$g === void 0 ? void 0 : _uninformedDataUser$g.map(function (d) {
    var displayName = d.displayName,
      userId = d.userId,
      employeeId = d.employeeId,
      profileUrl = d.profileUrl,
      leaveStatus = d.leaveStatus;
    var date = moment(startDate).local().format("DD MMM YYYY");
    return {
      displayName: displayName,
      date: date,
      status: leaveStatus,
      employeeId: employeeId,
      profileUrl: profileUrl
    };
  });
  if ((uninformedDataUser === null || uninformedDataUser === void 0 ? void 0 : (_uninformedDataUser$g2 = uninformedDataUser.getUninformedLeaveDetails) === null || _uninformedDataUser$g2 === void 0 ? void 0 : _uninformedDataUser$g2.length) !== 0 && (uninformedDataUser === null || uninformedDataUser === void 0 ? void 0 : (_uninformedDataUser$g3 = uninformedDataUser.getUninformedLeaveDetails) === null || _uninformedDataUser$g3 === void 0 ? void 0 : _uninformedDataUser$g3.length) < LIMIT && !isUninformedLeaveAllLoaded) {
    setIsUninformedLeaveAllLoaded(true);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, (uninformedDataUser === null || uninformedDataUser === void 0 ? void 0 : (_uninformedDataUser$g4 = uninformedDataUser.getUninformedLeaveDetails) === null || _uninformedDataUser$g4 === void 0 ? void 0 : _uninformedDataUser$g4.length) !== 0 ? /*#__PURE__*/React.createElement(TableGrid, {
    columns: columns,
    data: dataTable,
    handleLoadMore: handleUninformedLoadMore,
    isAllLoaded: isUninformedLeaveAllLoaded,
    isLoadingMore: isUninformedLeaveLoadingMore,
    isLoadMoreButton: isUninformedLeaveLoadMoreButton,
    userParameterCheck: userParameterCheck,
    tabData: tabData
  }) : /*#__PURE__*/React.createElement("div", {
    className: "daily-no-data-tab"
  }, " No data"));
};
export default DailyAttendance;